module.exports = __webpack_public_path__ + "static/media/anim-6-delete.fc47831f.png";